/**
 * @generated SignedSource<<6f0b48b58ffba7645b2b5e2f01a0d8af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssetRecordListPaginationQuery$variables = {
  after?: string | null;
  assetId: string;
  first: number;
};
export type AssetRecordListPaginationQueryVariables = AssetRecordListPaginationQuery$variables;
export type AssetRecordListPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HistoryTabAssetList_assetRecords">;
};
export type AssetRecordListPaginationQueryResponse = AssetRecordListPaginationQuery$data;
export type AssetRecordListPaginationQuery = {
  variables: AssetRecordListPaginationQueryVariables;
  response: AssetRecordListPaginationQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "assetId",
    "variableName": "assetId"
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganizationUser",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetRecordListPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HistoryTabAssetList_assetRecords"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssetRecordListPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AssetRecordConnection",
        "kind": "LinkedField",
        "name": "assetRecordsByAsset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetRecordEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notes",
                        "storageKey": null
                      }
                    ],
                    "type": "NoteRecord",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      }
                    ],
                    "type": "ImageRecord",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TaskCompletionRecord",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Measurement",
                        "kind": "LinkedField",
                        "name": "measurement",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MeasurementTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MeasurementRecord",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "assetId"
        ],
        "handle": "connection",
        "key": "AssetRecordList_assetRecordsByAsset",
        "kind": "LinkedHandle",
        "name": "assetRecordsByAsset"
      }
    ]
  },
  "params": {
    "cacheID": "05893bf192348baaf3cd5fb69df3a76a",
    "id": null,
    "metadata": {},
    "name": "AssetRecordListPaginationQuery",
    "operationKind": "query",
    "text": "query AssetRecordListPaginationQuery(\n  $after: String\n  $assetId: ID!\n  $first: Int!\n) {\n  ...HistoryTabAssetList_assetRecords_2HEEH6\n}\n\nfragment HistoryTabAssetList_assetRecords_2HEEH6 on Query {\n  assetRecordsByAsset(assetId: $assetId, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        __typename\n        ...NoteRecordItem_noteRecord\n        ...ImageRecordItem_imageRecord\n        ...TaskCompletionRecordItem_taskCompletionRecord\n        ...MeasurementRecordItem_measurementRecord\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ImageRecordItem_imageRecord on ImageRecord {\n  id\n  createdAt\n  author {\n    id\n    firstName\n    lastName\n  }\n  imageUrl\n}\n\nfragment MeasurementRecordItem_measurementRecord on MeasurementRecord {\n  id\n  createdAt\n  author {\n    id\n    firstName\n    lastName\n  }\n  measurement {\n    id\n    value\n    template {\n      id\n      name\n    }\n  }\n}\n\nfragment NoteRecordItem_noteRecord on NoteRecord {\n  id\n  createdAt\n  author {\n    id\n    firstName\n    lastName\n  }\n  notes\n}\n\nfragment TaskCompletionRecordItem_taskCompletionRecord on TaskCompletionRecord {\n  id\n  createdAt\n  author {\n    id\n    firstName\n    lastName\n  }\n  task {\n    id\n    template {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbf0178d5a17675b84c12dbe41f82ff3";

export default node;
